<template>
  <div>
    <ModalComponent
      :visible="showModal"
      @update:visible="updateVisibilityModal"
    >
      <!-- Fill in capital here -->
      <div class="container-modal-small">
        <div class="modal-title">Request a quote</div>
        <div class="border-header"></div>
        <div class="modal-icon">
          <img
            class="filter-primary"
            src="/images/icon/cart.svg"
            alt="Save Icon"
            style="height: 100px"
          />
        </div>
        <div
          class="color-primary"
          style="display: flex; justify-content: center; font-size: 1em"
        >
          <h1>Ready to request a quote?</h1>
        </div>

        <div style="display: flex; justify-content: center; font-size: 1em">
          If you want to change the details of your request after submission,
          you’ll need to
        </div>
        <div
          style="
            display: flex;
            justify-content: center;
            font-size: 1em;
            margin-bottom: 20px;
          "
        >
          email us at
          <a href="mailto:hello@edm8ker.com" style="margin-left: 6px">
            hello@edm8ker.com
          </a>
        </div>

        <div class="modal-button">
          <button
            :class="['btn', 'btn-discard', { disabled: buttonsDisabled }]"
            :disabled="buttonsDisabled"
            @click="triggerCancel"
            style="min-width: 100px"
          >
            Cancel
          </button>
          <button
            :class="['btn', 'btn-save', { disabled: buttonsDisabled }]"
            :disabled="buttonsDisabled"
            @click="triggerConfirm"
            style="
              padding: 0.5em 1em;
              min-width: 120px;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <div v-if="isLoading" class="spinner-small"></div>
            <span v-if="!isLoading">Confirm</span>
            <span v-else style="margin-left: 8px">Processing...</span>
          </button>
        </div>
      </div>
    </ModalComponent>
  </div>
</template>

<script setup>
import { ref, defineExpose, defineEmits } from "vue";
import ModalComponent from "@/components/ModalComponent.vue";

const showModal = ref(false);
const buttonsDisabled = ref(false);
const isLoading = ref(false);

const emit = defineEmits(["confirm", "cancel"]);

function updateVisibilityModal(visible) {
  showModal.value = visible;
  if (visible) {
    enableButtons();
    setLoading(false);
  }
}

function triggerConfirm() {
  setLoading(true);
  disableButtons();
  emit("confirm");
  // updateVisibilityModal(false); // Tutup modal setelah konfirmasi
}

function triggerCancel() {
  emit("cancel");
  updateVisibilityModal(false); // Tutup modal setelah cancel
}

function disableButtons() {
  buttonsDisabled.value = true;
}

function enableButtons() {
  buttonsDisabled.value = false;
}

function setLoading(loading) {
  isLoading.value = loading;
}

defineExpose({
  updateVisibilityModal,
  disableButtons,
  enableButtons,
  setLoading,
  triggerConfirm,
});
</script>

<style>
.btn.disabled {
  background-color: #ccc;
  /* Warna latar belakang untuk tombol yang dinonaktifkan */
  color: #666;
  /* Warna teks untuk tombol yang dinonaktifkan */
  cursor: not-allowed;
  /* Gaya kursor untuk tombol yang dinonaktifkan */
}

.btn-discard.disabled {
  background-color: #e0e0e0;
  /* Warna khusus untuk tombol discard yang dinonaktifkan */
}

.btn-save.disabled {
  background-color: #a0a0a0;
  /* Warna khusus untuk tombol save yang dinonaktifkan */
}

.spinner-small {
  width: 16px;
  height: 16px;
  border: 2px solid #ffffff;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>

<style scoped>
.modal-title {
  font-size: 1.5em;
  font-weight: 600;
  color: var(--primary-blue);
}

.border-header {
  border-bottom: 1px solid var(--primary-blue);
  margin: 10px 0;
}

.modal-icon {
  display: flex;
  justify-content: center;
}

.modal-button {
  display: flex;
  justify-content: center;
  gap: 10px;
}
</style>
